// extracted by mini-css-extract-plugin
module.exports = {"navigation":"_25d45facb5--navigation--llpyy","list":"_25d45facb5--list--LLCLZ"};